/*	Collapsible list groups for Bootstrap
 */

(function(){
	$(document).ready(function(){

		$('.collapsible-list-groups .active').on('click', function(){
			var $header = $(this);

			$header.next('.content-links').stop().slideToggle();
			$header.toggleClass("dropup");
		});
	});
})();